import type { ProjectRequestParams } from '@/api/v4/projects.api';
import { fetchProjects } from '@/api/v4/projects.api';
import { QueryKey } from '@/config/query-client';
import { selectedCompaniesState } from '@/features/companies/companies.state';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

const resolveParamAvailableProjects = (
  entityToShareId: string,
): ProjectRequestParams => ({
  excludeOrganizations: [entityToShareId],
});

export const useProjectSearchResults = (searchPhrase?: string) => {
  const selectedCompanies = useAtomValue(selectedCompaniesState);

  const fetchProjectSearchResults = () => {
    if (!selectedCompanies.length || searchPhrase === '') return [];

    const params =
      selectedCompanies.length === 1 && selectedCompanies[0].organizationId
        ? resolveParamAvailableProjects(selectedCompanies[0].organizationId)
        : {};

    return fetchProjects({ ...params, search: searchPhrase });
  };

  const queryKey = searchPhrase
    ? [QueryKey.ProjectSearchResults, searchPhrase]
    : [QueryKey.ProjectSearchResults];

  return useQuery({
    queryKey: queryKey,
    queryFn: fetchProjectSearchResults,
    staleTime: 1000 * 10,
    enabled: !!searchPhrase,
  });
};
